// src/data/products.js

export const products = [
  // ============ ELECTRONICS ============
  {
    id: '1',
    name: 'iPhone 15 Pro Max 256GB',
    brand: 'Apple',
    price: 134900,
    mrp: 159900,
    discount: 16,
    rating: 4.8,
    reviews: 15234,
    stock: 25,
    image: 'https://images.unsplash.com/photo-1695048133142-1a20484d2569?w=500',
    category: 'Electronics',
    subcategory: 'Smartphones',
    tag: 'Bestseller',
    description: 'Experience the ultimate smartphone with A17 Pro chip, titanium design, and advanced camera system',
    keywords: ['iphone', 'apple', 'smartphone', 'mobile', 'phone', 'ios', 'premium']
  },
  {
    id: '2',
    name: 'Samsung Galaxy S24 Ultra',
    brand: 'Samsung',
    price: 124999,
    mrp: 144999,
    discount: 14,
    rating: 4.7,
    reviews: 12456,
    stock: 20,
    image: 'https://images.unsplash.com/photo-1610945415295-d9bbf067e59c?w=500',
    category: 'Electronics',
    subcategory: 'Smartphones',
    tag: 'Top Rated',
    description: 'Flagship Samsung smartphone with S Pen, AI features, and 200MP camera',
    keywords: ['samsung', 'galaxy', 'smartphone', 'mobile', 'phone', 'android', 's24']
  },
  {
    id: '3',
    name: 'MacBook Pro 16" M3 Max',
    brand: 'Apple',
    price: 249900,
    mrp: 279900,
    discount: 11,
    rating: 4.9,
    reviews: 8934,
    stock: 12,
    image: 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=500',
    category: 'Electronics',
    subcategory: 'Laptops',
    tag: 'Premium',
    description: 'Professional laptop with M3 Max chip, stunning Liquid Retina XDR display',
    keywords: ['macbook', 'apple', 'laptop', 'mac', 'computer', 'pro', 'm3']
  },
  {
    id: '4',
    name: 'Sony WH-1000XM5 Headphones',
    brand: 'Sony',
    price: 26990,
    mrp: 34990,
    discount: 23,
    rating: 4.8,
    reviews: 23456,
    stock: 45,
    image: 'https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb?w=500',
    category: 'Electronics',
    subcategory: 'Audio',
    tag: 'Hot Deal',
    description: 'Industry-leading noise canceling headphones with exceptional sound quality',
    keywords: ['headphones', 'sony', 'wireless', 'noise canceling', 'audio', 'music']
  },
  {
    id: '5',
    name: 'iPad Pro 12.9" M2 Chip',
    brand: 'Apple',
    price: 109900,
    mrp: 129900,
    discount: 15,
    rating: 4.7,
    reviews: 9876,
    stock: 18,
    image: 'https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=500',
    category: 'Electronics',
    subcategory: 'Tablets',
    tag: 'Trending',
    description: 'Powerful tablet with M2 chip, ProMotion display, and Apple Pencil support',
    keywords: ['ipad', 'apple', 'tablet', 'pro', 'm2', 'touch']
  },
  {
    id: '6',
    name: 'Dell XPS 15 OLED Laptop',
    brand: 'Dell',
    price: 154990,
    mrp: 184990,
    discount: 16,
    rating: 4.6,
    reviews: 6789,
    stock: 15,
    image: 'https://images.unsplash.com/photo-1593642632823-8f785ba67e45?w=500',
    category: 'Electronics',
    subcategory: 'Laptops',
    tag: 'Popular',
    description: 'Premium Windows laptop with stunning OLED display and powerful performance',
    keywords: ['dell', 'xps', 'laptop', 'windows', 'oled', 'computer']
  },
  {
    id: '7',
    name: 'Apple Watch Ultra 2',
    brand: 'Apple',
    price: 89900,
    mrp: 99900,
    discount: 10,
    rating: 4.8,
    reviews: 11234,
    stock: 30,
    image: 'https://images.unsplash.com/photo-1579586337278-3befd40fd17a?w=500',
    category: 'Electronics',
    subcategory: 'Wearables',
    tag: 'New Launch',
    description: 'Rugged smartwatch with advanced health tracking and fitness features',
    keywords: ['apple watch', 'smartwatch', 'watch', 'fitness', 'health', 'wearable']
  },
  {
    id: '8',
    name: 'Samsung 65" QLED 4K Smart TV',
    brand: 'Samsung',
    price: 124990,
    mrp: 164990,
    discount: 24,
    rating: 4.6,
    reviews: 5432,
    stock: 10,
    image: 'https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?w=500',
    category: 'Electronics',
    subcategory: 'TV',
    tag: 'Big Saving',
    description: 'Premium 4K QLED smart TV with Quantum HDR and built-in Alexa',
    keywords: ['samsung', 'tv', 'television', 'qled', '4k', 'smart tv', 'large screen']
  },
  {
    id: '9',
    name: 'JBL Flip 6 Portable Speaker',
    brand: 'JBL',
    price: 10999,
    mrp: 14999,
    discount: 27,
    rating: 4.5,
    reviews: 18934,
    stock: 50,
    image: 'https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=500',
    category: 'Electronics',
    subcategory: 'Audio',
    tag: 'Best Value',
    description: 'Waterproof portable Bluetooth speaker with powerful sound',
    keywords: ['jbl', 'speaker', 'bluetooth', 'portable', 'wireless', 'audio', 'music']
  },
  {
    id: '10',
    name: 'Canon EOS R6 Mark II Camera',
    brand: 'Canon',
    price: 219990,
    mrp: 249990,
    discount: 12,
    rating: 4.9,
    reviews: 3456,
    stock: 8,
    image: 'https://images.unsplash.com/photo-1606983340126-99ab4feaa64a?w=500',
    category: 'Electronics',
    subcategory: 'Cameras',
    tag: 'Professional',
    description: 'Professional mirrorless camera with 24.2MP sensor and advanced autofocus',
    keywords: ['canon', 'camera', 'dslr', 'mirrorless', 'photography', 'professional']
  },
  {
    id: '11',
    name: 'AirPods Pro 2nd Generation',
    brand: 'Apple',
    price: 24900,
    mrp: 26900,
    discount: 7,
    rating: 4.8,
    reviews: 34567,
    stock: 60,
    image: 'https://images.unsplash.com/photo-1600294037681-c80b4cb5b434?w=500',
    category: 'Electronics',
    subcategory: 'Audio',
    tag: 'Bestseller',
    description: 'Premium wireless earbuds with active noise cancellation and spatial audio',
    keywords: ['airpods', 'apple', 'earbuds', 'wireless', 'bluetooth', 'tws', 'noise canceling']
  },
  {
    id: '12',
    name: 'PlayStation 5 Console',
    brand: 'Sony',
    price: 49990,
    mrp: 54990,
    discount: 9,
    rating: 4.9,
    reviews: 28934,
    stock: 15,
    image: 'https://images.unsplash.com/photo-1606144042614-b2417e99c4e3?w=500',
    category: 'Electronics',
    subcategory: 'Gaming',
    tag: 'Hot',
    description: 'Next-gen gaming console with ultra-fast SSD and ray tracing',
    keywords: ['playstation', 'ps5', 'gaming', 'console', 'sony', 'video games']
  },

  // ============ FASHION ============
  {
    id: '13',
    name: 'Premium Cotton Casual Shirt',
    brand: 'Allen Solly',
    price: 1299,
    mrp: 2499,
    discount: 48,
    rating: 4.3,
    reviews: 12345,
    stock: 100,
    image: 'https://images.unsplash.com/photo-1596755094514-f87e34085b2c?w=500',
    category: 'Fashion',
    subcategory: 'Men',
    tag: 'Bestseller',
    description: 'Comfortable premium cotton casual shirt for everyday wear',
    keywords: ['shirt', 'casual', 'men', 'cotton', 'fashion', 'clothing']
  },
  {
    id: '14',
    name: 'Slim Fit Denim Jeans',
    brand: 'Levis',
    price: 1999,
    mrp: 3999,
    discount: 50,
    rating: 4.5,
    reviews: 23456,
    stock: 80,
    image: 'https://images.unsplash.com/photo-1542272604-787c3835535d?w=500',
    category: 'Fashion',
    subcategory: 'Men',
    tag: 'Popular',
    description: 'Classic slim fit denim jeans with premium quality fabric',
    keywords: ['jeans', 'denim', 'pants', 'men', 'levis', 'fashion', 'casual']
  },
  {
    id: '15',
    name: 'Floral Print Maxi Dress',
    brand: 'Zara',
    price: 2499,
    mrp: 4999,
    discount: 50,
    rating: 4.6,
    reviews: 8765,
    stock: 45,
    image: 'https://images.unsplash.com/photo-1572804013309-59a88b7e92f1?w=500',
    category: 'Fashion',
    subcategory: 'Women',
    tag: 'Trending',
    description: 'Beautiful floral print maxi dress perfect for summer',
    keywords: ['dress', 'maxi', 'women', 'floral', 'fashion', 'summer', 'zara']
  },
  {
    id: '16',
    name: 'Leather Biker Jacket',
    brand: 'H&M',
    price: 4999,
    mrp: 8999,
    discount: 44,
    rating: 4.4,
    reviews: 5678,
    stock: 25,
    image: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?w=500',
    category: 'Fashion',
    subcategory: 'Men',
    tag: 'Premium',
    description: 'Stylish leather biker jacket for modern men',
    keywords: ['jacket', 'leather', 'biker', 'men', 'fashion', 'winter', 'outerwear']
  },
  {
    id: '17',
    name: 'Running Sports Shoes',
    brand: 'Nike',
    price: 6995,
    mrp: 10995,
    discount: 36,
    rating: 4.7,
    reviews: 34567,
    stock: 60,
    image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=500',
    category: 'Fashion',
    subcategory: 'Footwear',
    tag: 'Bestseller',
    description: 'High-performance running shoes with superior cushioning',
    keywords: ['nike', 'shoes', 'running', 'sports', 'footwear', 'sneakers', 'athletic']
  },
  {
    id: '18',
    name: 'Designer Handbag',
    brand: 'Michael Kors',
    price: 12999,
    mrp: 19999,
    discount: 35,
    rating: 4.5,
    reviews: 4567,
    stock: 20,
    image: 'https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=500',
    category: 'Fashion',
    subcategory: 'Women',
    tag: 'Luxury',
    description: 'Elegant designer handbag with premium leather finish',
    keywords: ['handbag', 'bag', 'purse', 'women', 'luxury', 'designer', 'fashion']
  },
  {
    id: '19',
    name: 'Classic Polo T-Shirt',
    brand: 'US Polo',
    price: 899,
    mrp: 1799,
    discount: 50,
    rating: 4.3,
    reviews: 45678,
    stock: 150,
    image: 'https://images.unsplash.com/photo-1625910513413-5fc42def4d44?w=500',
    category: 'Fashion',
    subcategory: 'Men',
    tag: 'Value',
    description: 'Comfortable classic polo t-shirt for casual wear',
    keywords: ['tshirt', 'polo', 'men', 'casual', 'fashion', 'comfortable']
  },
  {
    id: '20',
    name: 'Ethnic Silk Saree',
    brand: 'FabIndia',
    price: 3499,
    mrp: 6999,
    discount: 50,
    rating: 4.6,
    reviews: 8765,
    stock: 35,
    image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=500',
    category: 'Fashion',
    subcategory: 'Women',
    tag: 'Traditional',
    description: 'Traditional silk saree with elegant design and rich fabric',
    keywords: ['saree', 'silk', 'ethnic', 'traditional', 'women', 'indian', 'wedding']
  },
  {
    id: '21',
    name: 'Formal Blazer Suit',
    brand: 'Raymond',
    price: 8999,
    mrp: 15999,
    discount: 44,
    rating: 4.5,
    reviews: 3456,
    stock: 20,
    image: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=500',
    category: 'Fashion',
    subcategory: 'Men',
    tag: 'Formal',
    description: 'Premium formal blazer suit for business and special occasions',
    keywords: ['blazer', 'suit', 'formal', 'men', 'business', 'office', 'professional']
  },
  {
    id: '22',
    name: 'Casual Sneakers',
    brand: 'Adidas',
    price: 4999,
    mrp: 7999,
    discount: 38,
    rating: 4.6,
    reviews: 23456,
    stock: 70,
    image: 'https://images.unsplash.com/photo-1549298916-b41d501d3772?w=500',
    category: 'Fashion',
    subcategory: 'Footwear',
    tag: 'Trending',
    description: 'Stylish casual sneakers perfect for everyday wear',
    keywords: ['sneakers', 'adidas', 'shoes', 'casual', 'footwear', 'comfortable', 'sports']
  },
  {
    id: '23',
    name: 'Cotton Kurti Set',
    brand: 'Biba',
    price: 1299,
    mrp: 2599,
    discount: 50,
    rating: 4.4,
    reviews: 12345,
    stock: 90,
    image: 'https://images.unsplash.com/photo-1583391733956-6c78276477e2?w=500',
    category: 'Fashion',
    subcategory: 'Women',
    tag: 'Ethnic',
    description: 'Comfortable cotton kurti set with traditional prints',
    keywords: ['kurti', 'ethnic', 'women', 'indian', 'traditional', 'cotton', 'comfortable']
  },
  {
    id: '24',
    name: 'Aviator Sunglasses',
    brand: 'Ray-Ban',
    price: 7999,
    mrp: 12999,
    discount: 38,
    rating: 4.7,
    reviews: 15678,
    stock: 40,
    image: 'https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=500',
    category: 'Fashion',
    subcategory: 'Accessories',
    tag: 'Premium',
    description: 'Classic aviator sunglasses with UV protection',
    keywords: ['sunglasses', 'aviator', 'rayban', 'accessories', 'eyewear', 'fashion']
  },

  // ============ HOME & LIVING ============
  {
    id: '25',
    name: 'L-Shaped Sectional Sofa',
    brand: 'Urban Ladder',
    price: 45999,
    mrp: 65999,
    discount: 30,
    rating: 4.5,
    reviews: 3456,
    stock: 10,
    image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=500',
    category: 'Home & Living',
    subcategory: 'Furniture',
    tag: 'Premium',
    description: 'Spacious L-shaped sectional sofa with premium upholstery',
    keywords: ['sofa', 'couch', 'furniture', 'living room', 'sectional', 'home']
  },
  {
    id: '26',
    name: 'Queen Size Bed with Storage',
    brand: 'Godrej Interio',
    price: 32999,
    mrp: 45999,
    discount: 28,
    rating: 4.4,
    reviews: 2345,
    stock: 8,
    image: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=500',
    category: 'Home & Living',
    subcategory: 'Furniture',
    tag: 'Bestseller',
    description: 'Queen size bed with built-in storage compartments',
    keywords: ['bed', 'furniture', 'bedroom', 'storage', 'queen', 'home']
  },
  {
    id: '27',
    name: 'Modern Dining Table Set',
    brand: 'Home Centre',
    price: 28999,
    mrp: 39999,
    discount: 28,
    rating: 4.3,
    reviews: 1876,
    stock: 12,
    image: 'https://images.unsplash.com/photo-1617806118233-18e1de247200?w=500',
    category: 'Home & Living',
    subcategory: 'Furniture',
    tag: 'Popular',
    description: 'Contemporary dining table set with 6 chairs',
    keywords: ['dining table', 'table', 'furniture', 'dining', 'chairs', 'home']
  },
  {
    id: '28',
    name: 'LED Ceiling Chandelier',
    brand: 'Philips',
    price: 8999,
    mrp: 14999,
    discount: 40,
    rating: 4.5,
    reviews: 4567,
    stock: 25,
    image: 'https://images.unsplash.com/photo-1524484485831-a92ffc0de03f?w=500',
    category: 'Home & Living',
    subcategory: 'Lighting',
    tag: 'Trending',
    description: 'Modern LED ceiling chandelier with dimming feature',
    keywords: ['chandelier', 'light', 'lighting', 'ceiling', 'led', 'home', 'decoration']
  },
  {
    id: '29',
    name: 'Persian Area Rug 6x9',
    brand: 'Carpet Vista',
    price: 15999,
    mrp: 25999,
    discount: 38,
    rating: 4.6,
    reviews: 2134,
    stock: 15,
    image: 'https://images.unsplash.com/photo-1600166898405-da9535204843?w=500',
    category: 'Home & Living',
    subcategory: 'Decor',
    tag: 'Luxury',
    description: 'Handwoven Persian area rug with intricate patterns',
    keywords: ['rug', 'carpet', 'floor', 'decor', 'home', 'persian', 'luxury']
  },
  {
    id: '30',
    name: 'Memory Foam Mattress King',
    brand: 'Sleepwell',
    price: 24999,
    mrp: 35999,
    discount: 31,
    rating: 4.7,
    reviews: 8765,
    stock: 20,
    image: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=500',
    category: 'Home & Living',
    subcategory: 'Bedroom',
    tag: 'Bestseller',
    description: 'Premium memory foam mattress for ultimate comfort',
    keywords: ['mattress', 'memory foam', 'bedroom', 'sleep', 'king', 'comfortable']
  },
  {
    id: '31',
    name: 'Wall Art Canvas Set',
    brand: 'Art Street',
    price: 2999,
    mrp: 5999,
    discount: 50,
    rating: 4.4,
    reviews: 5678,
    stock: 40,
    image: 'https://images.unsplash.com/photo-1513519245088-0e12902e35ca?w=500',
    category: 'Home & Living',
    subcategory: 'Decor',
    tag: 'Value',
    description: 'Beautiful wall art canvas set for home decoration',
    keywords: ['wall art', 'art', 'canvas', 'decor', 'painting', 'home', 'decoration']
  },
  {
    id: '32',
    name: 'Modular Kitchen Cabinet',
    brand: 'Livspace',
    price: 89999,
    mrp: 129999,
    discount: 31,
    rating: 4.5,
    reviews: 1234,
    stock: 5,
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=500',
    category: 'Home & Living',
    subcategory: 'Kitchen',
    tag: 'Premium',
    description: 'Modern modular kitchen cabinet with smart storage solutions',
    keywords: ['kitchen', 'cabinet', 'modular', 'storage', 'furniture', 'home']
  },
  {
    id: '33',
    name: 'Smart Air Purifier',
    brand: 'Dyson',
    price: 34999,
    mrp: 44999,
    discount: 22,
    rating: 4.8,
    reviews: 6789,
    stock: 18,
    image: 'https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=500',
    category: 'Home & Living',
    subcategory: 'Appliances',
    tag: 'Hot',
    description: 'Advanced air purifier with HEPA filter and smart features',
    keywords: ['air purifier', 'purifier', 'appliance', 'home', 'health', 'clean air']
  },
  {
    id: '34',
    name: 'Luxury Bedding Set',
    brand: 'Spaces',
    price: 4999,
    mrp: 8999,
    discount: 44,
    rating: 4.5,
    reviews: 7654,
    stock: 35,
    image: 'https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=500',
    category: 'Home & Living',
    subcategory: 'Bedroom',
    tag: 'Trending',
    description: 'Premium luxury bedding set with soft cotton fabric',
    keywords: ['bedding', 'bed sheet', 'bedroom', 'linen', 'home', 'comfortable']
  },

  // ============ BEAUTY ============
  {
    id: '35',
    name: 'Vitamin C Serum 30ml',
    brand: 'The Ordinary',
    price: 899,
    mrp: 1499,
    discount: 40,
    rating: 4.6,
    reviews: 34567,
    stock: 100,
    image: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=500',
    category: 'Beauty',
    subcategory: 'Skincare',
    tag: 'Bestseller',
    description: 'Brightening vitamin C serum for radiant skin',
    keywords: ['serum', 'vitamin c', 'skincare', 'beauty', 'face', 'anti-aging']
  },
  {
    id: '36',
    name: 'Matte Lipstick Collection',
    brand: 'MAC',
    price: 1899,
    mrp: 2500,
    discount: 24,
    rating: 4.7,
    reviews: 23456,
    stock: 80,
    image: 'https://images.unsplash.com/photo-1586495777744-4413f21062fa?w=500',
    category: 'Beauty',
    subcategory: 'Makeup',
    tag: 'Trending',
    description: 'Long-lasting matte lipstick in various shades',
    keywords: ['lipstick', 'makeup', 'cosmetics', 'beauty', 'matte', 'mac']
  },
  {
    id: '37',
    name: 'Luxury Perfume 100ml',
    brand: 'Dior',
    price: 8999,
    mrp: 12999,
    discount: 31,
    rating: 4.8,
    reviews: 12345,
    stock: 30,
    image: 'https://images.unsplash.com/photo-1541643600914-78b084683601?w=500',
    category: 'Beauty',
    subcategory: 'Fragrance',
    tag: 'Premium',
    description: 'Elegant luxury perfume with long-lasting fragrance',
    keywords: ['perfume', 'fragrance', 'scent', 'beauty', 'luxury', 'dior']
  },
  {
    id: '38',
    name: 'Hair Straightener Pro',
    brand: 'Dyson',
    price: 34999,
    mrp: 44999,
    discount: 22,
    rating: 4.7,
    reviews: 8765,
    stock: 20,
    image: 'https://images.unsplash.com/photo-1522338140262-f46f5913618a?w=500',
    category: 'Beauty',
    subcategory: 'Haircare',
    tag: 'Luxury',
    description: 'Professional hair straightener with heat control technology',
    keywords: ['hair straightener', 'straightener', 'haircare', 'beauty', 'styling', 'dyson']
  },
  {
    id: '39',
    name: 'Foundation Palette',
    brand: 'Maybelline',
    price: 799,
    mrp: 1299,
    discount: 38,
    rating: 4.4,
    reviews: 45678,
    stock: 120,
    image: 'https://images.unsplash.com/photo-1512496015851-a90fb38ba796?w=500',
    category: 'Beauty',
    subcategory: 'Makeup',
    tag: 'Value',
    description: 'Complete foundation palette with multiple shades',
    keywords: ['foundation', 'makeup', 'cosmetics', 'beauty', 'face', 'maybelline']
  },
  {
    id: '40',
    name: 'Retinol Night Cream',
    brand: 'Neutrogena',
    price: 1299,
    mrp: 1999,
    discount: 35,
    rating: 4.5,
    reviews: 15678,
    stock: 60,
    image: 'https://images.unsplash.com/photo-1570194065650-d99fb4bedf0a?w=500',
    category: 'Beauty',
    subcategory: 'Skincare',
    tag: 'Popular',
    description: 'Anti-aging retinol night cream for youthful skin',
    keywords: ['cream', 'night cream', 'retinol', 'skincare', 'beauty', 'anti-aging']
  },
  {
    id: '41',
    name: 'Hair Growth Oil 200ml',
    brand: 'Kama Ayurveda',
    price: 1499,
    mrp: 2499,
    discount: 40,
    rating: 4.3,
    reviews: 23456,
    stock: 70,
    image: 'https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=500',
    category: 'Beauty',
    subcategory: 'Haircare',
    tag: 'Natural',
    description: 'Natural ayurvedic hair growth oil with herbal ingredients',
    keywords: ['hair oil', 'oil', 'haircare', 'beauty', 'ayurvedic', 'natural', 'growth']
  },
  {
    id: '42',
    name: 'Eye Makeup Kit',
    brand: 'Lakme',
    price: 1599,
    mrp: 2999,
    discount: 47,
    rating: 4.4,
    reviews: 18765,
    stock: 50,
    image: 'https://images.unsplash.com/photo-1583241800698-e8ab01828929?w=500',
    category: 'Beauty',
    subcategory: 'Makeup',
    tag: 'Trending',
    description: 'Complete eye makeup kit with eyeshadow and eyeliner',
    keywords: ['eye makeup', 'makeup', 'eyeshadow', 'cosmetics', 'beauty', 'lakme']
  },
  {
    id: '43',
    name: 'Sunscreen SPF 50+',
    brand: 'La Shield',
    price: 699,
    mrp: 999,
    discount: 30,
    rating: 4.6,
    reviews: 34567,
    stock: 150,
    image: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=500',
    category: 'Beauty',
    subcategory: 'Skincare',
    tag: 'Essential',
    description: 'Broad spectrum sunscreen with SPF 50+ protection',
    keywords: ['sunscreen', 'spf', 'skincare', 'beauty', 'sun protection', 'uv']
  },
  {
    id: '44',
    name: 'Nail Polish Set 12pc',
    brand: 'OPI',
    price: 2499,
    mrp: 3999,
    discount: 38,
    rating: 4.5,
    reviews: 9876,
    stock: 40,
    image: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?w=500',
    category: 'Beauty',
    subcategory: 'Nails',
    tag: 'Gift Set',
    description: 'Premium nail polish set with 12 vibrant colors',
    keywords: ['nail polish', 'nails', 'cosmetics', 'beauty', 'manicure', 'opi']
  },

  // ============ SPORTS ============
  {
    id: '45',
    name: 'Professional Yoga Mat',
    brand: 'Manduka',
    price: 3499,
    mrp: 5999,
    discount: 42,
    rating: 4.7,
    reviews: 12345,
    stock: 60,
    image: 'https://images.unsplash.com/photo-1601925260368-ae2f83cf8b7f?w=500',
    category: 'Sports',
    subcategory: 'Fitness',
    tag: 'Bestseller',
    description: 'High-quality yoga mat with superior grip and cushioning',
    keywords: ['yoga mat', 'yoga', 'fitness', 'exercise', 'sports', 'workout']
  },
  {
    id: '46',
    name: 'Adjustable Dumbbells Set',
    brand: 'Bowflex',
    price: 24999,
    mrp: 34999,
    discount: 29,
    rating: 4.8,
    reviews: 8765,
    stock: 25,
    image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=500',
    category: 'Sports',
    subcategory: 'Gym',
    tag: 'Premium',
    description: 'Adjustable dumbbells with multiple weight options',
    keywords: ['dumbbell', 'weights', 'gym', 'fitness', 'strength', 'workout', 'sports']
  },
  {
    id: '47',
    name: 'Cricket Bat English Willow',
    brand: 'MRF',
    price: 8999,
    mrp: 14999,
    discount: 40,
    rating: 4.6,
    reviews: 5678,
    stock: 30,
    image: 'https://images.unsplash.com/photo-1531415074968-036ba1b575da?w=500',
    category: 'Sports',
    subcategory: 'Cricket',
    tag: 'Popular',
    description: 'Professional cricket bat made from English willow',
    keywords: ['cricket bat', 'bat', 'cricket', 'sports', 'mrf', 'english willow']
  },
  {
    id: '48',
    name: 'Running Treadmill',
    brand: 'PowerMax',
    price: 45999,
    mrp: 65999,
    discount: 30,
    rating: 4.5,
    reviews: 4567,
    stock: 10,
    image: 'https://images.unsplash.com/photo-1576678927484-cc907957088c?w=500',
    category: 'Sports',
    subcategory: 'Gym',
    tag: 'Hot Deal',
    description: 'Electric treadmill with multiple speed and incline settings',
    keywords: ['treadmill', 'running', 'gym', 'fitness', 'cardio', 'exercise', 'sports']
  },
  {
    id: '49',
    name: 'Football Official Size',
    brand: 'Nike',
    price: 2499,
    mrp: 3999,
    discount: 38,
    rating: 4.5,
    reviews: 15678,
    stock: 80,
    image: 'https://images.unsplash.com/photo-1614632537197-38a17061c2bd?w=500',
    category: 'Sports',
    subcategory: 'Football',
    tag: 'Trending',
    description: 'Official size football with premium synthetic leather',
    keywords: ['football', 'soccer', 'ball', 'sports', 'nike', 'outdoor']
  },
  {
    id: '50',
    name: 'Badminton Racket Pro',
    brand: 'Yonex',
    price: 4999,
    mrp: 7999,
    discount: 38,
    rating: 4.7,
    reviews: 9876,
    stock: 40,
    image: 'https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=500',
    category: 'Sports',
    subcategory: 'Badminton',
    tag: 'Bestseller',
    description: 'Professional badminton racket with carbon fiber frame',
    keywords: ['badminton', 'racket', 'sports', 'yonex', 'indoor', 'game']
  },
  {
    id: '51',
    name: 'Swimming Goggles',
    brand: 'Speedo',
    price: 1499,
    mrp: 2499,
    discount: 40,
    rating: 4.4,
    reviews: 7654,
    stock: 70,
    image: 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=500',
    category: 'Sports',
    subcategory: 'Swimming',
    tag: 'Essential',
    description: 'Anti-fog swimming goggles with UV protection',
    keywords: ['swimming', 'goggles', 'swim', 'sports', 'water', 'speedo']
  },
  {
    id: '52',
    name: 'Resistance Bands Set',
    brand: 'Fitbit',
    price: 999,
    mrp: 1999,
    discount: 50,
    rating: 4.3,
    reviews: 23456,
    stock: 100,
    image: 'https://images.unsplash.com/photo-1598632640487-6ea4a4e8b963?w=500',
    category: 'Sports',
    subcategory: 'Fitness',
    tag: 'Value',
    description: 'Set of resistance bands for strength training and flexibility',
    keywords: ['resistance bands', 'bands', 'fitness', 'workout', 'exercise', 'sports']
  },
  {
    id: '53',
    name: 'Cycling Helmet Pro',
    brand: 'Giro',
    price: 5999,
    mrp: 8999,
    discount: 33,
    rating: 4.6,
    reviews: 3456,
    stock: 25,
    image: 'https://images.unsplash.com/photo-1557803175-2f8c4becf1ee?w=500',
    category: 'Sports',
    subcategory: 'Cycling',
    tag: 'Safety',
    description: 'Professional cycling helmet with advanced ventilation system',
    keywords: ['helmet', 'cycling', 'bike', 'safety', 'sports', 'outdoor']
  },
  {
    id: '54',
    name: 'Tennis Racket Carbon',
    brand: 'Wilson',
    price: 7999,
    mrp: 12999,
    discount: 38,
    rating: 4.7,
    reviews: 6543,
    stock: 20,
    image: 'https://images.unsplash.com/photo-1617083934555-ac7d4d0b134c?w=500',
    category: 'Sports',
    subcategory: 'Tennis',
    tag: 'Premium',
    description: 'Professional tennis racket with carbon fiber construction',
    keywords: ['tennis', 'racket', 'sports', 'wilson', 'outdoor', 'game']
  },

  // ============ NEW ARRIVALS ============
  {
    id: '55',
    name: 'Smart Ring Health Tracker',
    brand: 'Oura',
    price: 29999,
    mrp: 34999,
    discount: 14,
    rating: 4.6,
    reviews: 2345,
    stock: 15,
    image: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=500',
    category: 'New Arrivals',
    subcategory: 'Wearables',
    tag: 'New Launch',
    description: 'Advanced smart ring with health and sleep tracking features',
    keywords: ['smart ring', 'wearable', 'fitness tracker', 'health', 'new', 'gadget']
  },
  {
    id: '56',
    name: 'Portable Projector 4K',
    brand: 'Samsung',
    price: 89999,
    mrp: 109999,
    discount: 18,
    rating: 4.7,
    reviews: 1234,
    stock: 10,
    image: 'https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=500',
    category: 'New Arrivals',
    subcategory: 'Electronics',
    tag: 'New',
    description: 'Compact 4K portable projector with wireless connectivity',
    keywords: ['projector', '4k', 'portable', 'samsung', 'new', 'entertainment']
  },
  {
    id: '57',
    name: 'Electric Scooter Foldable',
    brand: 'Xiaomi',
    price: 45999,
    mrp: 55999,
    discount: 18,
    rating: 4.5,
    reviews: 3456,
    stock: 12,
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=500',
    category: 'New Arrivals',
    subcategory: 'Mobility',
    tag: 'New Launch',
    description: 'Foldable electric scooter with long battery life',
    keywords: ['electric scooter', 'scooter', 'xiaomi', 'new', 'mobility', 'transport']
  },
  {
    id: '58',
    name: 'Smart Home Hub',
    brand: 'Google',
    price: 9999,
    mrp: 12999,
    discount: 23,
    rating: 4.6,
    reviews: 5678,
    stock: 30,
    image: 'https://images.unsplash.com/photo-1558089687-f282ffcbc126?w=500',
    category: 'New Arrivals',
    subcategory: 'Smart Home',
    tag: 'Trending',
    description: 'Central hub for controlling all your smart home devices',
    keywords: ['smart home', 'hub', 'google', 'automation', 'new', 'iot']
  },
  {
    id: '59',
    name: 'Wireless Charging Pad 3-in-1',
    brand: 'Belkin',
    price: 4999,
    mrp: 6999,
    discount: 29,
    rating: 4.5,
    reviews: 4567,
    stock: 45,
    image: 'https://images.unsplash.com/photo-1622552245550-6909ec918e8c?w=500',
    category: 'New Arrivals',
    subcategory: 'Accessories',
    tag: 'New',
    description: '3-in-1 wireless charging pad for phone, watch, and earbuds',
    keywords: ['wireless charging', 'charger', 'belkin', 'new', 'accessory', 'qi']
  },
  {
    id: '60',
    name: 'Robot Vacuum Cleaner',
    brand: 'iRobot',
    price: 34999,
    mrp: 45999,
    discount: 24,
    rating: 4.7,
    reviews: 6789,
    stock: 20,
    image: 'https://images.unsplash.com/photo-1558618047-f4b511f8f6e6?w=500',
    category: 'New Arrivals',
    subcategory: 'Home',
    tag: 'Hot',
    description: 'Smart robot vacuum cleaner with app control and mapping',
    keywords: ['robot vacuum', 'vacuum', 'cleaner', 'irobot', 'new', 'smart home']
  },
  {
    id: '61',
    name: 'Standing Desk Electric',
    brand: 'FlexiSpot',
    price: 25999,
    mrp: 35999,
    discount: 28,
    rating: 4.6,
    reviews: 2345,
    stock: 15,
    image: 'https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89?w=500',
    category: 'New Arrivals',
    subcategory: 'Furniture',
    tag: 'New Launch',
    description: 'Height-adjustable electric standing desk for ergonomic work',
    keywords: ['standing desk', 'desk', 'electric', 'furniture', 'new', 'office']
  },
  {
    id: '62',
    name: 'Massage Gun Pro',
    brand: 'Theragun',
    price: 15999,
    mrp: 21999,
    discount: 27,
    rating: 4.8,
    reviews: 8765,
    stock: 25,
    image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=500',
    category: 'New Arrivals',
    subcategory: 'Wellness',
    tag: 'Trending',
    description: 'Professional massage gun for muscle recovery and pain relief',
    keywords: ['massage gun', 'massage', 'wellness', 'recovery', 'new', 'health']
  },
  {
    id: '63',
    name: 'Smart Water Bottle',
    brand: 'HidrateSpark',
    price: 3999,
    mrp: 5499,
    discount: 27,
    rating: 4.4,
    reviews: 3456,
    stock: 50,
    image: 'https://images.unsplash.com/photo-1602143407151-7111542de6e8?w=500',
    category: 'New Arrivals',
    subcategory: 'Fitness',
    tag: 'New',
    description: 'Smart water bottle with hydration tracking and LED reminders',
    keywords: ['smart bottle', 'water bottle', 'fitness', 'hydration', 'new', 'health']
  },
  {
    id: '64',
    name: 'VR Headset Pro',
    brand: 'Meta',
    price: 49999,
    mrp: 59999,
    discount: 17,
    rating: 4.7,
    reviews: 5678,
    stock: 10,
    image: 'https://images.unsplash.com/photo-1622979135225-d2ba269cf1ac?w=500',
    category: 'New Arrivals',
    subcategory: 'Gaming',
    tag: 'Hot',
    description: 'Next-gen VR headset with high-resolution displays and immersive experience',
    keywords: ['vr headset', 'vr', 'virtual reality', 'gaming', 'meta', 'new']
  },

  // ============ DEALS ============
  {
    id: '65',
    name: 'Bluetooth Earbuds TWS',
    brand: 'Boat',
    price: 999,
    mrp: 2999,
    discount: 67,
    rating: 4.2,
    reviews: 56789,
    stock: 200,
    image: 'https://images.unsplash.com/photo-1590658268037-6bf12165a8df?w=500',
    category: 'Deals',
    subcategory: 'Audio',
    tag: 'Flash Sale',
    description: 'True wireless earbuds with deep bass and long battery life',
    keywords: ['earbuds', 'tws', 'bluetooth', 'wireless', 'boat', 'audio', 'deal']
  },
  {
    id: '66',
    name: 'Smart Watch Fitness',
    brand: 'Noise',
    price: 1999,
    mrp: 5999,
    discount: 67,
    rating: 4.3,
    reviews: 34567,
    stock: 150,
    image: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500',
    category: 'Deals',
    subcategory: 'Wearables',
    tag: 'Deal of Day',
    description: 'Fitness smartwatch with heart rate monitor and multiple sport modes',
    keywords: ['smartwatch', 'fitness watch', 'wearable', 'noise', 'deal', 'tracker']
  },
  {
    id: '67',
    name: 'Power Bank 20000mAh',
    brand: 'MI',
    price: 999,
    mrp: 2499,
    discount: 60,
    rating: 4.5,
    reviews: 45678,
    stock: 180,
    image: 'https://images.unsplash.com/photo-1609091839311-d5365f9ff1c5?w=500',
    category: 'Deals',
    subcategory: 'Accessories',
    tag: 'Lightning Deal',
    description: 'High-capacity power bank with fast charging support',
    keywords: ['power bank', 'charger', 'battery', 'mi', 'deal', 'portable']
  },
  {
    id: '68',
    name: 'Wireless Mouse Ergonomic',
    brand: 'Logitech',
    price: 799,
    mrp: 1999,
    discount: 60,
    rating: 4.4,
    reviews: 23456,
    stock: 100,
    image: 'https://images.unsplash.com/photo-1527864550417-7fd91fc51a46?w=500',
    category: 'Deals',
    subcategory: 'Computer',
    tag: 'Hot Deal',
    description: 'Ergonomic wireless mouse with precision tracking',
    keywords: ['mouse', 'wireless mouse', 'logitech', 'computer', 'accessory', 'deal']
  },
  {
    id: '69',
    name: 'LED Desk Lamp Smart',
    brand: 'Philips',
    price: 1499,
    mrp: 3499,
    discount: 57,
    rating: 4.5,
    reviews: 12345,
    stock: 80,
    image: 'https://images.unsplash.com/photo-1507473885765-e6ed057f782c?w=500',
    category: 'Deals',
    subcategory: 'Home',
    tag: 'Flash Sale',
    description: 'Smart LED desk lamp with adjustable brightness and color temperature',
    keywords: ['desk lamp', 'lamp', 'led', 'smart', 'philips', 'deal', 'lighting']
  },
  {
    id: '70',
    name: 'Bluetooth Speaker Mini',
    brand: 'JBL',
    price: 1999,
    mrp: 4999,
    discount: 60,
    rating: 4.6,
    reviews: 34567,
    stock: 120,
    image: 'https://images.unsplash.com/photo-1589003077984-894e133dabab?w=500',
    category: 'Deals',
    subcategory: 'Audio',
    tag: 'Deal of Day',
    description: 'Compact Bluetooth speaker with powerful sound and waterproof design',
    keywords: ['speaker', 'bluetooth speaker', 'jbl', 'portable', 'audio', 'deal']
  },
  {
    id: '71',
    name: 'Webcam HD 1080p',
    brand: 'Logitech',
    price: 2499,
    mrp: 5999,
    discount: 58,
    rating: 4.4,
    reviews: 8765,
    stock: 60,
    image: 'https://images.unsplash.com/photo-1587826080692-f439cd0b70da?w=500',
    category: 'Deals',
    subcategory: 'Computer',
    tag: 'Hot',
    description: 'Full HD webcam with autofocus and built-in microphone',
    keywords: ['webcam', 'camera', 'logitech', 'video', 'streaming', 'deal']
  },
  {
    id: '72',
    name: 'USB C Hub 7-in-1',
    brand: 'Anker',
    price: 1999,
    mrp: 4499,
    discount: 56,
    rating: 4.5,
    reviews: 15678,
    stock: 90,
    image: 'https://images.unsplash.com/photo-1625723044792-44de16ccb4e9?w=500',
    category: 'Deals',
    subcategory: 'Accessories',
    tag: 'Lightning Deal',
    description: '7-in-1 USB-C hub with HDMI, USB ports, and SD card reader',
    keywords: ['usb hub', 'usb c', 'hub', 'anker', 'adapter', 'deal', 'accessory']
  },
  {
    id: '73',
    name: 'Electric Kettle 1.5L',
    brand: 'Prestige',
    price: 699,
    mrp: 1499,
    discount: 53,
    rating: 4.3,
    reviews: 23456,
    stock: 150,
    image: 'https://images.unsplash.com/photo-1594213114663-d94db9b17e19?w=500',
    category: 'Deals',
    subcategory: 'Kitchen',
    tag: 'Value Deal',
    description: 'Fast-boiling electric kettle with auto shut-off feature',
    keywords: ['kettle', 'electric kettle', 'prestige', 'kitchen', 'appliance', 'deal']
  },
  {
    id: '74',
    name: 'Digital Weighing Scale',
    brand: 'HealthSense',
    price: 599,
    mrp: 1499,
    discount: 60,
    rating: 4.2,
    reviews: 12345,
    stock: 100,
    image: 'https://images.unsplash.com/photo-1576669801945-7a346954da5a?w=500',
    category: 'Deals',
    subcategory: 'Health',
    tag: 'Flash Sale',
    description: 'Digital weighing scale with high precision and large LCD display',
    keywords: ['weighing scale', 'scale', 'digital', 'health', 'fitness', 'deal']
  }
];

export const searchKeywords = {
  // Electronics
  'mobile': ['1', '2'],
  'phone': ['1', '2'],
  'smartphone': ['1', '2'],
  'iphone': ['1'],
  'samsung': ['2', '8'],
  'galaxy': ['2'],
  'apple': ['1', '3', '5', '7', '11'],
  'laptop': ['3', '6'],
  'macbook': ['3'],
  'dell': ['6'],
  'xps': ['6'],
  'headphones': ['4', '11'],
  'earbuds': ['11', '65'],
  'airpods': ['11'],
  'sony': ['4', '12'],
  'ipad': ['5'],
  'tablet': ['5'],
  'watch': ['7', '66'],
  'smartwatch': ['7', '66'],
  'tv': ['8'],
  'television': ['8'],
  'qled': ['8'],
  'speaker': ['9', '70'],
  'bluetooth': ['9', '65', '70'],
  'jbl': ['9', '70'],
  'camera': ['10'],
  'canon': ['10'],
  'gaming': ['12'],
  'playstation': ['12'],
  'ps5': ['12'],
  
  // Fashion
  'shirt': ['13'],
  'jeans': ['14'],
  'denim': ['14'],
  'dress': ['15'],
  'jacket': ['16'],
  'leather': ['16'],
  'shoes': ['17', '22'],
  'nike': ['17', '49'],
  'running': ['17', '48'],
  'bag': ['18'],
  'handbag': ['18'],
  'tshirt': ['19'],
  'polo': ['19'],
  'saree': ['20'],
  'silk': ['20'],
  'blazer': ['21'],
  'suit': ['21'],
  'sneakers': ['22'],
  'adidas': ['22'],
  'kurti': ['23'],
  'ethnic': ['20', '23'],
  'sunglasses': ['24'],
  'rayban': ['24'],
  
  // Home & Living
  'sofa': ['25'],
  'couch': ['25'],
  'bed': ['26'],
  'furniture': ['25', '26', '27'],
  'table': ['27'],
  'dining': ['27'],
  'light': ['28'],
  'chandelier': ['28'],
  'led': ['28', '69'],
  'rug': ['29'],
  'carpet': ['29'],
  'mattress': ['30'],
  'memory foam': ['30'],
  'art': ['31'],
  'canvas': ['31'],
  'kitchen': ['32', '73'],
  'cabinet': ['32'],
  'purifier': ['33'],
  'air purifier': ['33'],
  'dyson': ['33', '38'],
  'bedding': ['34'],
  
  // Beauty
  'serum': ['35'],
  'vitamin': ['35'],
  'skincare': ['35', '40', '43'],
  'lipstick': ['36'],
  'mac': ['36'],
  'makeup': ['36', '39', '42'],
  'perfume': ['37'],
  'fragrance': ['37'],
  'dior': ['37'],
  'straightener': ['38'],
  'hair': ['38', '41'],
  'foundation': ['39'],
  'maybelline': ['39'],
  'cream': ['40'],
  'retinol': ['40'],
  'oil': ['41'],
  'ayurvedic': ['41'],
  'eye makeup': ['42'],
  'lakme': ['42'],
  'sunscreen': ['43'],
  'spf': ['43'],
  'nail polish': ['44'],
  'opi': ['44'],
  
  // Sports
  'yoga': ['45'],
  'mat': ['45'],
  'dumbbell': ['46'],
  'weights': ['46'],
  'gym': ['46', '48'],
  'fitness': ['45', '46', '52', '63', '66'],
  'cricket': ['47'],
  'bat': ['47'],
  'mrf': ['47'],
  'treadmill': ['48'],
  'football': ['49'],
  'soccer': ['49'],
  'badminton': ['50'],
  'racket': ['50', '54'],
  'yonex': ['50'],
  'swimming': ['51'],
  'goggles': ['51'],
  'speedo': ['51'],
  'resistance': ['52'],
  'bands': ['52'],
  'helmet': ['53'],
  'cycling': ['53'],
  'bike': ['53'],
  'tennis': ['54'],
  'wilson': ['54'],
  
  // New Arrivals
  'smart ring': ['55'],
  'wearable': ['55', '66'],
  'projector': ['56'],
  '4k': ['56'],
  'scooter': ['57'],
  'electric': ['57', '61', '73'],
  'xiaomi': ['57'],
  'smart home': ['58', '60'],
  'google': ['58'],
  'hub': ['58', '72'],
  'wireless charging': ['59'],
  'charger': ['59', '67'],
  'belkin': ['59'],
  'robot': ['60'],
  'vacuum': ['60'],
  'irobot': ['60'],
  'standing desk': ['61'],
  'desk': ['61', '69'],
  'massage': ['62'],
  'theragun': ['62'],
  'water bottle': ['63'],
  'vr': ['64'],
  'virtual reality': ['64'],
  'meta': ['64'],
  
  // Deals
  'deal': ['65', '66', '67', '68', '69', '70', '71', '72', '73', '74'],
  'discount': ['65', '66', '67', '68', '69', '70', '71', '72', '73', '74'],
  'offer': ['65', '66', '67', '68', '69', '70', '71', '72', '73', '74'],
  'boat': ['65'],
  'tws': ['65'],
  'noise': ['66'],
  'powerbank': ['67'],
  'power bank': ['67'],
  'mi': ['67'],
  'mouse': ['68'],
  'wireless': ['68', '70'],
  'logitech': ['68', '71'],
  'lamp': ['69'],
  'philips': ['28', '69'],
  'webcam': ['71'],
  'usb': ['72'],
  'anker': ['72'],
  'kettle': ['73'],
  'prestige': ['73'],
  'scale': ['74'],
  'weighing': ['74']
};

export const categories = [
  {
    id: 1,
    name: 'Electronics',
    slug: 'electronics',
    icon: '📱',
    image: 'https://images.unsplash.com/photo-1498049794561-7780e7231661?w=500',
    description: 'Latest gadgets and tech devices',
    productCount: 12
  },
  {
    id: 2,
    name: 'Fashion',
    slug: 'fashion',
    icon: '👕',
    image: 'https://images.unsplash.com/photo-1445205170230-053b83016050?w=500',
    description: 'Trendy clothing and accessories',
    productCount: 12
  },
  {
    id: 3,
    name: 'Home & Living',
    slug: 'home-&-living',
    icon: '🏠',
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=500',
    description: 'Furniture and home decor',
    productCount: 10
  },
  {
    id: 4,
    name: 'Beauty',
    slug: 'beauty',
    icon: '💄',
    image: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=500',
    description: 'Skincare, makeup and fragrances',
    productCount: 10
  },
  {
    id: 5,
    name: 'Sports',
    slug: 'sports',
    icon: '⚽',
    image: 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=500',
    description: 'Sports equipment and fitness gear',
    productCount: 10
  },
  {
    id: 6,
    name: 'New Arrivals',
    slug: 'new-arrivals',
    icon: '✨',
    image: 'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=500',
    description: 'Latest products just launched',
    productCount: 10
  },
  {
    id: 7,
    name: 'Deals',
    slug: 'deals',
    icon: '🔥',
    image: 'https://images.unsplash.com/photo-1607083206869-4c7672e72a8a?w=500',
    description: 'Best deals and discounts',
    productCount: 10
  }
];

export const banners = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=1200',
    title: 'Summer Sale',
    subtitle: 'Up to 70% Off',
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=1200',
    title: 'Tech Gadgets',
    subtitle: 'New Arrivals',
    gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=1200',
    title: 'Home Makeover',
    subtitle: 'Premium Collection',
    gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
  }
];

// Helper function to get products by keyword
export const getProductsByKeyword = (keyword) => {
  const lowerKeyword = keyword.toLowerCase();
  const productIds = searchKeywords[lowerKeyword] || [];
  return products.filter(p => productIds.includes(p.id));
};

// Helper function to search products
export const searchProducts = (query) => {
  if (!query || query.trim().length < 2) return [];

  const lowerQuery = query.toLowerCase().trim();
  const searchTerms = lowerQuery.split(' ');

  return products.filter(product => {
    const searchableFields = [
      product.name,
      product.brand,
      product.category,
      product.subcategory,
      product.tag,
      product.description || '',
      ...(product.keywords || [])
    ].map(field => field?.toLowerCase() || '');

    const combinedText = searchableFields.join(' ');

    // Check if all terms match
    return searchTerms.every(term => combinedText.includes(term)) ||
           searchTerms.some(term => combinedText.includes(term));
  });
};